import _ from 'lodash';
import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Notification } from './notification';
import styles from './notifications.scss';
import {
  isNotificationWithKey,
  NotificationModel,
} from './notifications.types';

interface OwnProps {
  dataHook?: string;
  notifications: NotificationModel[];
  onNotificationClose(notification: NotificationModel): void;
  onReady?(notification: NotificationModel): void;
}

type Props = OwnProps & DefaultProps & WrappedComponentProps;

interface DefaultProps {
  onReady(notification: NotificationModel): void;
}

class NotificationsComponent extends React.Component<Props, {}> {
  public static defaultProps: DefaultProps = {
    onReady: _.noop,
  };

  private getMessage(notification: NotificationModel): string {
    const { intl } = this.props;

    return isNotificationWithKey(notification)
      ? intl.formatMessage(
          { id: notification.key },
          { ...notification.options },
        )
      : notification.message;
  }

  public render() {
    const { dataHook, notifications, onNotificationClose, onReady } = this
      .props as Props;

    return (
      <ul className={styles.notifications}>
        {_.map(notifications, (notification: NotificationModel) => (
          <li key={notification.id} className={styles.notificationWrapper}>
            <Notification
              dataHook={dataHook}
              theme={notification.theme}
              show={notification.show}
              onClose={() => onNotificationClose(notification)}
              onReady={() => onReady(notification)}
            >
              <Notification.TextLabel>
                {this.getMessage(notification)}
              </Notification.TextLabel>
              <Notification.CloseButton />
            </Notification>
          </li>
        ))}
      </ul>
    );
  }
}

export const Notifications = injectIntl(NotificationsComponent);
